import { Datatype } from '../../../../expressions/datatype/Datatype.ts';
import { getWidgetFieldDatatypeOptions } from '../../../../expressions/datatype/getWidgetFieldDatatypeOptions.ts';
import {
  type IReference,
  ReferenceType,
} from '../../../../expressions/references/IReference.ts';
import { type IReferencePath } from '../../../../expressions/references/IReferencePath.ts';
import { type ISingleSelectWidget } from './ISingleSelectWidget.ts';

export function getSingleSelectWidgetReference(
  path: IReferencePath,
  widget: ISingleSelectWidget,
): IReference {
  return {
    type: ReferenceType.Widget,
    widgetType: widget.type,
    path,
    id: widget.id,
    code: widget.code,
    label: widget.code,
    field: {
      type: Datatype.String,
      options: getWidgetFieldDatatypeOptions(widget),
    },
  };
}
